import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {getToken} from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import userRoute from '@/router/router.json'
import urlJoin from "url-join";
import {parseState} from "@/utils/skip";

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/index','/'] // no redirect whitelist
let hasAddedRoutes = false
router.beforeEach(async(to, from, next) => {
    NProgress.start()
    document.title = getPageTitle(to.meta.title)// set page title

    // 检测设备类型
    const deviceType = store.getters.device || store.state.app.device
    if (deviceType === 'mobile' && to.path !== '/mobile' &&  to.path !== '/mobile_menu') {
        // 如果是移动设备且不是访问移动端路由，则重定向到移动端路由
        next('/mobile')
        return
    } else if (deviceType === 'pc' && to.path === '/mobile') {
        // 如果是PC端访问移动端路由，则重定向到首页
        next('/')
        return
    }

    // 无论是否有 token，都需要先加载动态路由
    if (!hasAddedRoutes) {
        try {
            const menuList = store.getters.menuList
            if(menuList.length == 0){
                const accessRoutes = await store.dispatch('route/generateRoutes',userRoute)
                await accessRoutes.push({ path: '*', redirect: '/404', hidden: true })
                await accessRoutes.forEach(route => {
                    router.addRoute(route)
                })
                hasAddedRoutes = true
                // 添加完路由后立即重新导航，不再执行后续逻辑
                next({ ...to, replace: true })
                return
            }
            hasAddedRoutes = true
        } catch (error) {
            Message.error('路由加载失败')
            console.error(error)
            hasAddedRoutes = true
        }
    }
    const hasDictionary = store.getters.dictionary
    const hasDictionaryObj = store.getters.dictionaryObj
    if (!hasDictionary || !hasDictionaryObj) {
        try {
            await store.dispatch('user/get_correlation')
        } catch (error) {
            Message.error('获取字典数据失败')
        }
    }
    await store.dispatch('user/get_constantList')

    const hasToken = getToken()
    if (hasToken) {
        const hasGetUserInfo = store.getters.name
        const state = to.query.state;
        const route = state ? parseState(state) : ''
        if (hasGetUserInfo) {
            // next()
            if (route && route.path) {
                next({ path: urlJoin(to.path, route.path), query: route.query })
            }else {
                next()
            }
        } else {
            try {
                await store.dispatch('user/getInfo')
                // generate accessible routes map based on roles
                // next()
                if (route && route.path) {
                    next({ path: urlJoin(to.path, route.path), query: route.query })
                }else {
                    next()
                }
            } catch (error) {
                await store.dispatch('user/resetToken')
                Message.error(error || 'Has Error')
                next(`/index`)
            }
        }
    } else {
        // next()
        if (whiteList.indexOf(to.path) !== -1) {
            if(to.query.code){
                await store.dispatch('user/login',to.query)
                next({ ...to, replace: true })
            }else{
                next()
            }
        } else {
            // other pages that do not have permission to access are redirected to the home page.
            next()
        }
    }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
